import { render } from "./microblog.vue?vue&type=template&id=3fe391d8&ts=true"
import script from "./microblog.vue?vue&type=script&lang=ts"
export * from "./microblog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__